export const EVENT = {
    CHANGE: "change"
}

export default class {
    /**
     * 
     * @param {Api} api 
     */
    constructor(api) {
        this.api = api
        this.customers = null
        this.onEvent = null
        this.API_URL = '/api/admin'
    }

    /**
     * set event handler
     * @param {Function} onEvent
     */
    setEventHandler(onEvent) {
        this.onEvent = onEvent
    }

    _triggerEvent(name, data) {
        if (this.onEvent) this.onEvent(name, data)
    }

    /**
     * Get all users
     */
    async getUsers() {
        const url = `${this.API_URL}/users`
        return await this.api.request('GET', url, null)
    }

    /**
     * Update user
     * @param {<Object>} data 
     */
    async updateUser(data) {
        const url = `${this.API_URL}/user/${data._id}`
        return await this.api.request('PUT', url, data)
    }

    /**
     * Change password by user
     * @param {String} userId 
     * @param {Object} data 
     */
    async updateUserPassword(userId, data) {
        const url = `${this.API_URL}/user/set-password/${userId}`
        return await this.api.request('PUT', url, data)
    }

    /**
    * Register a user
    * 
    * @param {<Object>} userInfo 
    */
    async registerUser(userInfo) {
        const url = `${this.API_URL}/user`
        return await this.api.request('POST', url, userInfo)
    }


    /**
     * Delete user
     * @param {String} id 
     */
    async deleteUser(id) {
        const url = `${this.API_URL}/user/${id}`
        return await this.api.request('DELETE', url, null)
    }

    /**
     * Get roles list
     */
    async getRoles() {
        const url = `${this.API_URL}/roles`
        return await this.api.request('GET', url, null)
    }

    /**
     * Add role
     * @param {Object} data
     */
    async addRole(data) {
        const url = `${this.API_URL}/role`
        return await this.api.request('POST', url, data)
    }

    /**
     * Update role
     */
    async updateRole(data) {
        const url = `${this.API_URL}/role/${data._id}`
        return await this.api.request('PUT', url, data)
    }

    /**
     * Delete role
     */
    async deleteRole(id) {
        const url = `${this.API_URL}/role/${id}`
        return await this.api.request('DELETE', url, null)
    }

    /**
     * Get permissions
     */
    async getPermissions() {
        const url = `${this.API_URL}/permissions`
        return await this.api.request('GET', url, null)
    }
}